const entity = {
  name: {
    singular: 'Curso',
    plural: 'Cursos'
  },
  styles: {
    gridTemplateColumns: '30% 1fr',
    gridTemplateAreas: '"main quinary" "secondary secondary" "quaternary tertiary"'
  },
  collection: 'courses',
  tableHeaders: [
    { text: 'Título', value: 'title' },
    { text: 'URL Amigável', value: 'slug' },
    { text: 'Actions', value: 'action', sortable: false }
  ],
  model: {
    title: '',
    slug: '',
    fileTeaser: '',
    fileImageHome: '',
    advantages: [],
    generalInformations: [{
      title: '',
      description: '',
      position: 0
    }],
    body: '',
    summary: '',
    price: '',
    discount: '',
    additionalPages: [],
    imageGallery: []
  },
  schema: {
    groups: [
      {
        fields: [
          { type: 'input', inputType: 'text', label: 'Nome', model: 'title' },
          { type: 'input', inputType: 'text', label: 'Url Amigável', model: 'slug' },
          { type: 'input', inputType: 'text', label: 'Mensalidade', model: 'price' },
          { type: 'input', inputType: 'text', label: 'Desconto', model: 'discount' },
          { type: 'image', label: 'Imagem do Topo', model: 'fileTeaser', hideInput: true },
          { type: 'image', label: 'Imagem para cursos na home', model: 'fileImageHome', hideInput: true }
        ]
      },
      {
        fields: [
          { type: 'editor', label: 'Texto principal', model: 'body' }
        ]
      },
      {
        fields: [
          {
            type: 'array',
            label: 'Informações gerais',
            model: 'generalInformations',
            translations: {
              title: 'Título',
              description: 'Texto',
              position: 'Posição'
            }
          }
        ]
      },
      {
        fields: [
          {
            type: 'array',
            label: 'Páginas adicionais',
            model: 'additionalPages',
            translations: {
              title: 'Título',
              description: 'URL',
              position: 'Posição'
            }
          }
        ]
      },
      {
        fields: [
          { type: 'galleryCards', label: 'Vantagens', model: 'advantages' }
        ]
      }
    ]
  },
  formOptions: {
    validateAfterLoad: true,
    validateAfterChanged: true,
    validateAsync: true
  }
}

export default [
  {
    path: '/courses',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: 'courses' */ '../../components/Crud/CrudList.vue')
  }, {
    path: '/courses/new',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: 'courses' */ '../../components/Crud/CrudForm.vue')
  }, {
    path: '/courses/:id',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: 'courses' */ '../../components/Crud/CrudForm.vue')
  }
]
